/** Project-level shadow tokens */
export const shadows = {
  xs: '0 1px 2px rgba(16, 24, 40, 0.05)',
  sm: '0 1px 2px rgba(15, 23, 43, 0.04)',
  md: '0 2px 8px rgba(91, 108, 159, 0.12)',
  lg: '0 8px 28px rgba(15, 23, 43, 0.12)',
  xl: '0 16px 40px rgba(15, 23, 43, 0.14)',
  card: 'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  input: 'none',
  focus: '0 0 0 3px rgba(94, 65, 241, 0.1)',
};
